import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { API_SCHEME, API_HOST, API_PATH } from 'utils/env';

export const baseURI = '/nominas/historico-nombramientos/';

/**
 * GET Historicos Movimientos Empleados
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getHistoricosNombramientos = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Historico Movimiento Empleado
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getHistoricosNombramiento = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Historico Movimiento Empleado
 * @param {object} values
 * @returns {Promise<obejct|boolean>}
 */
export const postHistoricosNombramiento = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * PATCH Historico Moviemiento Empleado
 * @param {number} id
 * @param {object} values
 * @return {Promise<object|boolean>}
 */
export const patchHistoricosNombramiento = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * DELETE Historico Movimiento Empelado
 * @param {number} id
 */
export const deleteHistoricosNombramiento = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Elimiando correctamente');
    return true;
  } catch (err) {
    onError(err);
  }
  return false;
};

// /**
//  * GET Historico Movimientos Empleados Plantilla
//  * @param {object} params
//  * @returns {Promise<object[]>}
//  */
// export const getHistoricoMovimientosEmpleadosPlantilla = async () => {
//   try {
//     const response = await API.get(`${API_SCHEME}://${API_HOST}${API_PATH}nominas/historico-movimientos-empleados-obtener-plantilla`, {
//       headers: {
//         'Content-Type': 'application/ms-excel',
//       },
//       responseType: 'arraybuffer',
//     });
//     return response.data;
//   } catch (err) {
//     onError(err);
//   }
//   return [];
// };
